import React from 'react'
import PropTypes from 'prop-types'
import { localize } from 'helpers/translator'

import Confirm from 'views/confirm/confirm'

const GoogleSlidesUnauthorizedEdit = props => (
	<Confirm
		btOne={localize('google_slides_unauthorized_edit_learnMore')}
		btTwo={localize('google_slides_unauthorized_edit_editInNearpod')}
		alertMessage={localize('google_slides_unauthorized_edit_message')}
		alertTitle={localize('google_slides_unauthorized_edit_title')}
		centeredTitle={true}
		actionOne={props.handleLearnMore}
		actionTwo={props.handleEditInNearpod}
		closeAction={props.handleCloseConfirm}
	/>
)

GoogleSlidesUnauthorizedEdit.defaultProps = {
}

GoogleSlidesUnauthorizedEdit.propTypes = {
	handleEditInNearpod: PropTypes.func.isRequired,
	handleLearnMore: PropTypes.func.isRequired,
	handleCloseConfirm: PropTypes.func.isRequired,
}

export default GoogleSlidesUnauthorizedEdit
